import { render, staticRenderFns } from "./DeBroglieMatterWaveProViz.vue?vue&type=template&id=0ee3164a&scoped=true"
import script from "./DeBroglieMatterWaveProViz.vue?vue&type=script&lang=js"
export * from "./DeBroglieMatterWaveProViz.vue?vue&type=script&lang=js"
import style0 from "./DeBroglieMatterWaveProViz.vue?vue&type=style&index=0&id=0ee3164a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee3164a",
  null
  
)

export default component.exports